<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body class="i-body-custom">
      <cube-tab-bar
        v-model="selectedLabelDefault"
        :data="tabs"
        class="tab-bar-custom"
        showSlider>
      </cube-tab-bar>
      <div v-if="selectedLabelDefault === '理财师发起'" style="overflow:auto">
        <div class="specific-box">
          <div class="steps-desc">
            <div class="steps-desc-left">
              <img src="~@/assets/quto-left.png" alt="">
            </div>
            <div class="steps-desc-center">情况一：套印模式下，理财师发起的订单</div>
            <div class="steps-desc-right">
              <img src="~@/assets/quto-right.png" alt="">
            </div>
          </div>
          <div class="steps-item" v-for="(item, index) in itemsOneY" :key="index">
            <div class="item-title">{{item.title}}</div>
            <div class="item-content" v-html="item.content"></div>
          </div>
        </div>

        <div class="specific-box">
          <div class="steps-desc">
            <div class="steps-desc-left">
              <img src="~@/assets/quto-left.png" alt="">
            </div>
            <div class="steps-desc-center">情况二：UKEY托管人先签，理财师发起的订单</div>
            <div class="steps-desc-right">
              <img src="~@/assets/quto-right.png" alt="">
            </div>
          </div>
          <div class="steps-item" v-for="(item, index) in itemsOneE" :key="index">
            <div class="item-title">{{item.title}}</div>
            <div class="item-content" v-html="item.content"></div>
          </div>
        </div>

        <div class="specific-box">
          <div class="steps-desc">
            <div class="steps-desc-left">
              <img src="~@/assets/quto-left.png" alt="">
            </div>
            <div class="steps-desc-center">情况三：UKEY托管人后签，理财师发起的订单</div>
            <div class="steps-desc-right">
              <img src="~@/assets/quto-right.png" alt="">
            </div>
          </div>
          <div class="steps-item" v-for="(item, index) in itemsOneS" :key="index">
            <div class="item-title">{{item.title}}</div>
            <div class="item-content" v-html="item.content"></div>
          </div>
        </div>

      </div>
      <div v-if="selectedLabelDefault === '投资者发起'">
        <div class="specific-box">
          <div class="steps-desc">
            <div class="steps-desc-left">
              <img src="~@/assets/quto-left.png" alt="">
            </div>
            <div class="steps-desc-center">情况一：套印模式下，投资者发起的订单</div>
            <div class="steps-desc-right">
              <img src="~@/assets/quto-right.png" alt="">
            </div>
          </div>
          <div class="steps-item" v-for="(item, index) in itemsTwoY" :key="index">
            <div class="item-title">{{item.title}}</div>
            <div class="item-content" v-html="item.content"></div>
          </div>
        </div>

        <div class="specific-box">
          <div class="steps-desc">
            <div class="steps-desc-left">
              <img src="~@/assets/quto-left.png" alt="">
            </div>
            <div class="steps-desc-center">情况二：UKEY托管人先签，投资者发起的订单</div>
            <div class="steps-desc-right">
              <img src="~@/assets/quto-right.png" alt="">
            </div>
          </div>
          <div class="steps-item" v-for="(item, index) in itemsTwoE" :key="index">
            <div class="item-title">{{item.title}}</div>
            <div class="item-content" v-html="item.content"></div>
          </div>
        </div>

        <div class="specific-box">
          <div class="steps-desc">
            <div class="steps-desc-left">
              <img src="~@/assets/quto-left.png" alt="">
            </div>
            <div class="steps-desc-center">情况三：UKEY托管人后签，投资者发起的订单</div>
            <div class="steps-desc-right">
              <img src="~@/assets/quto-right.png" alt="">
            </div>
          </div>
          <div class="steps-item" v-for="(item, index) in itemsTwoS" :key="index">
            <div class="item-title">{{item.title}}</div>
            <div class="item-content" v-html="item.content"></div>
          </div>
        </div>
      </div>


    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedLabelDefault: '理财师发起',
      tabs: [
        {
          label: '理财师发起',
        },
        {
          label: '投资者发起',
        },
      ],
      itemsOneY: [
        {
          title: '1、预约确认',
          content: '投资者对理财师预约的产品进行预约确认',
        },
        {
          title: '2、合同签署',
          content: '投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署',
        },
        {
          title: '3、理财师签署',
          content: '投资者签署完成后，进入理财师签署风险揭示书',
        },
        {
          title: '4、签约成功',
          content: '三方协议签署成功',
        },
      ],
      itemsOneE: [
        {
          title: '1、预约确认',
          content: '投资者对理财师预约的产品进行预约确认',
        },
        {
          title: '2、托管人审核',
          content: '等待托管人对合同进行确认签署',
        },
        {
          title: '3、合同签署',
          content: '投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署',
        },
        {
          title: '4、理财师签署',
          content: '投资者签署完成后，进入理财师签署风险揭示书',
        },
        {
          title: '5、签约成功',
          content: '三方协议签署成功',
        },
      ],
      itemsOneS: [
        {
          title: '1、预约确认',
          content: '投资者对理财师预约的产品进行预约确认',
        },
        {
          title: '2、合同签署',
          content: '投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署',
        },
        {
          title: '3、托管人审核',
          content: '等待托管人对合同进行确认签署',
        },
        {
          title: '4、理财师签署',
          content: '投资者签署完成后，进入理财师签署风险揭示书',
        },
        {
          title: '5、签约成功',
          content: '三方协议签署成功',
        },
      ],
      itemsTwoY: [
        {
          title: '1、预约申请',
          content: '投资者对理财师预约的产品进行预约确认',
        },
        {
          title: '2、合同签署',
          content: '投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署',
        },
        {
          title: '3、理财师签署',
          content: '投资者签署完成后，进入理财师签署风险揭示书',
        },
        {
          title: '4、签约成功',
          content: '三方协议签署成功',
        },
      ],
      itemsTwoE: [
        {
          title: '1、预约申请',
          content: '投资者对理财师预约的产品进行预约确认',
        },
        {
          title: '2、托管人审核',
          content: '等待托管人对合同进行确认签署',
        },
        {
          title: '3、合同签署',
          content: '投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署',
        },
        {
          title: '4、理财师签署',
          content: '投资者签署完成后，进入理财师签署风险揭示书',
        },
        {
          title: '5、签约成功',
          content: '三方协议签署成功',
        },
      ],
      itemsTwoS: [
        {
          title: '1、预约申请',
          content: '投资者对理财师预约的产品进行预约确认',
        },
        {
          title: '2、合同签署',
          content: '投资者对订单进行合同签署包括：双录（若有）、风险揭示书签署、合同文件签署',
        },
        {
          title: '3、托管人审核',
          content: '等待托管人对合同进行确认签署',
        },
        {
          title: '4、理财师签署',
          content: '投资者签署完成后，进入理财师签署风险揭示书',
        },
        {
          title: '5、签约成功',
          content: '三方协议签署成功',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.i-body-custom {
  .specific-box {
    background: #fff;
    overflow:hidden;
    margin: 15px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.06);
    border-radius: 2px;
    .steps-desc {
      margin: 15px;
      color: #999;
      background: rgb(252, 229, 193);
      border-radius: 3px;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      padding: 15px 5px;
      font-size: 12px;
      align-content: center;
      .steps-desc-left,.steps-desc-right {
        img {
          width: 15px;
        }
      }
      .steps-desc-center {
        flex: .9;
      }
    }
    .steps-item {
      padding: 15px;
      border-bottom: 1px dashed #ccc;
      &:last-child {
        border-bottom: none;
      }
      &:first-child {
        border-bottom: none;
      }
      .item-title {
        font-size: 13px;
        color: #222222;
        margin-bottom: 10px;
      }
      .item-content {
        font-size: 13px;
        color: #999999;
      }
    }
  }
}

</style>
